








































import { Component, Emit, Watch, Vue } from 'vue-property-decorator';
import { newDedicatedMachineService } from '@/components/new-dedicated-machine/services/NewDedicatedMachineService';

@Component({})
export default class OperatingSystemSelector extends Vue {
  operatingSystemSelected: any = { id: -1, version: null, name: '' };
  operatingSystems: any = [];
  allOperatingSystems: any = [];
  selectedVersion: any = null;
  isAllSystemsShown = false;
  workspaceId = 0;
  regionId = 0;
  selectedSystemVersions: any = [];

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.getNewDedicatedMachine();
  }

  getNewDedicatedMachine() {
    newDedicatedMachineService
      .getOperatingSystems(this.workspaceId, this.regionId)
      .then((data: any) => {
        this.allOperatingSystems = data;
        this.operatingSystems = data.filter(
          (thing: any, index: any, self: any) => index === self.findIndex((t: any) => t.name === thing.name)
        );
      })
      .catch(() => {});
  }

  @Watch('selectedVersion')
  onSelectedVersionChanged(val: any) {
    if (val) {
      this.versionSelected();
    }
  }

  @Emit()
  osSelected(system: any) {
    this.operatingSystemSelected = system;
    if (system && system.version) {
      this.selectedVersion = system.id;
      this.selectedSystemVersions = this.allOperatingSystems.filter((item: any) => item.name === system.name);
    } else {
      this.selectedVersion = null;
    }
    return system;
  }

  @Emit()
  versionSelected() {
    if (this.selectedVersion) {
      return this.selectedSystemVersions.find(
        (item: any) => parseInt(item.id, 10) === parseInt(this.selectedVersion, 10)
      );
    }
  }
}
